import { render, staticRenderFns } from "./textlist.vue?vue&type=template&id=78fab4b2"
import script from "./textlist.vue?vue&type=script&lang=js"
export * from "./textlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports